import React, { useEffect, useRef, useState } from 'react';
import styled from 'App/styled';
import { titleId } from 'components/ListingPage/Scroll/constants';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 24px 8px 16px 8px;
  span {
    ${({ theme }) => theme.typography.bodyLarge};
    align-self: center;
  }
`;

const Text = styled.h1`
  margin: 0;
  ${({ theme }) => theme.typography.titleMedium};
  font-stretch: normal;
  font-style: normal;
`;

const Heading = styled.h2`
  margin: 0;
  ${({ theme }) => theme.typography.titleMedium};
  font-stretch: normal;
  font-style: normal;
`;

const VisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

interface Props {
  categoryName?: string;
  totalProducts?: number;
  title?: string;
}

function Title({ categoryName, totalProducts = 0, title }: Props) {
  const [ariaAnnouncement, setAriaAnnouncement] = useState('');
  const isFirstRender = useRef(true);

  useEffect(() => {
    // skip initial render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setAriaAnnouncement('');

    const timer = setTimeout(() => {
      setAriaAnnouncement(
        totalProducts > 0
          ? `${totalProducts} ${
              totalProducts === 1 ? 'product is' : 'products are'
            } available`
          : 'No products available'
      );
    }, 1300);

    return () => clearTimeout(timer);
  }, [totalProducts]);

  if (!categoryName && !title) {
    return null;
  }
  const text = (
    <>
      {categoryName}&nbsp;
      <span>({totalProducts})</span>
    </>
  );
  // let text = `${categoryName} (${<span>{totalProducts}</span>})`;
  let id = 'title';
  if (title) {
    id = titleId;
  }

  return (
    <Wrapper id={id}>
      {title?.length ? (
        <Heading>{title || text}</Heading>
      ) : (
        <>
          <Text
            aria-label={`${categoryName}, ${totalProducts} products available`}
          >
            {categoryName}&nbsp;
            <span aria-hidden="true">({totalProducts})</span>
          </Text>
          <VisuallyHidden
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            {ariaAnnouncement}
          </VisuallyHidden>
        </>
      )}
    </Wrapper>
  );
}

export default Title;
